import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import SubText from "components/shared/SubText";
import { useSelector } from "react-redux";
import { lazy, Suspense, useEffect, useState } from "react";
import PodcastService from "services/podcast/PodcastService";
import { Link } from "react-router-dom";
import { RouteName } from "constant/routeNames";
import PodcastcardSkeleton from "components/skeleton/PodcardSkeleton";
import ErrorBoundary from "components/error-fallbacks/ErrorFallBack";
import SectionHeading from "components/shared/SectionHeading";

const Podcastcard = lazy(() => import("pages/podcastPage/shared/Podcastcard"));

function WelcomePagePodcast() {
  const [podcasts, setPodcasts] = useState<any[]>([]);
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    PodcastService.getLatestPodcasts().then((res) => {
      setIsLoading(false);
      setPodcasts(res.data);
      // console.log(res.data);
    });
  }, []);
  return (
    <>
      {!isLoading && (
        <ErrorBoundary>
          <Suspense fallback={<PodcastcardSkeleton />}>
            <div className="mb-10">
              {podcasts && (
                <>
                  {/* top section */}
                  <div className="mt-10 mb-5 flex w-[95%] items-center justify-between">
                    <div>
                      <SectionHeading text="Discover Podcasts" className="font-bold" />
                    </div>
                    <Link
                      to={RouteName.SeeAllNewPodcastRoute}
                      className="group shrink-0"
                    >
                      <p className="flex items-center gap-1 text-sm font-bold text-[#F50537] transition-all duration-200 group-hover:gap-2">
                        See all
                        <span className="transition-transform duration-200 group-hover:translate-x-0.5">
                          →
                        </span>
                      </p>
                    </Link>
                  </div>
                  {/* coursel */}
                  <div className="">
                    <Swiper
                      slidesPerView={6}
                      breakpoints={{
                        0: {
                          slidesPerView: 1,
                        },
                        370: {
                          slidesPerView: 2,
                        },
                        700: {
                          slidesPerView: 3,
                        },
                        1000: {
                          slidesPerView: 4,
                        },
                        1200: {
                          slidesPerView: 5,
                        },
                        1400: {
                          slidesPerView: 6,
                        },
                        1600: {
                          slidesPerView: 7,
                        },
                      }}
                      modules={[Pagination, Navigation]}
                      navigation={true}
                      className="mt-8 mb-10 mySwiper"
                    >
                      {podcasts?.map((podcast: any, i: number) => (
                        <SwiperSlide key={i}>
                          <div className="mx-3 max-sm:mx-1">
                            <Podcastcard podcast={podcast} user={loggedInUser} />
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </>
              )}
            </div>
          </Suspense>
        </ErrorBoundary>
      )}
      {isLoading && <PodcastcardSkeleton />}
    </>
  );
}

export default WelcomePagePodcast;